import React from 'react';
import { TextField } from '@mui/material';
var TextFilter = function (_a) {
    var textColumn = _a.textColumn, onFilterChange = _a.onFilterChange;
    var handleOnChange = function (event) {
        onFilterChange(textColumn, event.target.value);
    };
    return (React.createElement(TextField, { className: "columnFilter textField", name: textColumn.name + "-filter", value: textColumn.filter ? textColumn.filter : '', onChange: handleOnChange, fullWidth: true, disabled: !textColumn.filterable }));
};
export default TextFilter;
//# sourceMappingURL=TextFilter.js.map